<template>
  <router-view />
  <SensitiveContentWarning />
</template>

<script setup>
import SensitiveContentWarning from '@/components/common/SensitiveContentWarning.vue'
</script>
